import styled from 'styled-components'
import { spacing } from '@chegg-ui/theme'

export { FeedbackCardsContainer as ClarityCardsContainer } from '../../styled'

export const ClaritySectionWrapper = styled.div`
  margin-top: ${spacing.px16};
`
